// extracted by mini-css-extract-plugin
module.exports = {"signInPage":"signin_signInPage__UqeBG","spinnerWrap":"signin_spinnerWrap__mGMba","signInSpin":"signin_signInSpin__tqaeC"};